import {
  AccountWalletCredentials,
  SessionAccountDataCredentials,
} from "@mezo/api"
import { isSupportedBitcoinAddress } from "@mezo/sdk"

import { SDK_NETWORK } from "#/shared/constants"

export const isEVMAddress = (address: string): boolean =>
  address.toLowerCase().startsWith("0x") && address.length === 42

export const isBitcoinAddress = (address: string): boolean =>
  isSupportedBitcoinAddress(address, SDK_NETWORK)

export const trimAddress = (address: string) =>
  address.length > 0 && (isEVMAddress(address) || isBitcoinAddress(address))
    ? `${address.slice(0, 5)}...${address.slice(-5)}`.toLowerCase()
    : address

export const normalizeAddress = (address: string): string =>
  address.toLowerCase()

export const isSameAddress = (address1: string, address2: string): boolean =>
  normalizeAddress(address1) === normalizeAddress(address2)

export const isAddressConnectedToAccount = (
  address: string,
  linkedAccounts: SessionAccountDataCredentials[],
) => {
  const walletAccounts = linkedAccounts.filter(
    (account) => account.type === "wallet",
  ) as AccountWalletCredentials[]

  return walletAccounts.find((account) =>
    isSameAddress(account.btcAddress ?? account.evmAddress, address),
  )
}
